import { Slot, useSegments } from "expo-router";

import PageLayout from "$src/core/components/templates/PageLayout";
import TabsLayout from "$src/core/components/templates/TabsLayout";
import LoadingPage from "$src/core/pages/LoadingPage/LoadingPage";
import useMenuQuery from "$src/core/queries/use-menu-query";

const TAB_ROUTES = [
  "(tabs)/(slot-1)/[slug]",
  "(tabs)/(slot-2)/[slug]",
  "(tabs)/(slot-3)/[slug]",
  "(tabs)/(slot-4)/[slug]",
  "(tabs)/(slot-5)/[slug]",
  "(tabs)/(slot-6)/[slug]",
  "(tabs)/(slot-7)/[slug]",
];

const Layout: React.FC = () => {
  const segments = useSegments();
  const { data: menu } = useMenuQuery();

  // The player is a full-screen experience with its own back button, so it
  // must render outside the tabs chrome — otherwise the web menu (nav bar +
  // tab bar) is shown around it.
  const isPlayerRoute = segments.at(-1) === "play";

  if (isPlayerRoute) {
    return <Slot />;
  }

  if (!menu) {
    return (
      <PageLayout>
        <LoadingPage />
      </PageLayout>
    );
  }

  return <TabsLayout routes={TAB_ROUTES} />;
};

export default Layout;
